import styled, { css, keyframes } from 'styled-components';

import coinSrc from 'assets/images/prize.min.png';
import mineSrc from 'assets/images/mine.min.png';
import bonusSrc from 'assets/icons/bonus_label.min.png';

const flipAnim = keyframes`
  0% {
    transform: rotateY(0deg) scale(1);
  }
  30% {
    transform: rotateY(160deg) scale(1.2);
  }
  100% {
    transform: rotateY(180deg) scale(1);
  }
`;

const tileStyle = css`
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  max-width: 100px;
  max-height: 100px;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const SButton = styled.button`
  flex: 0 0 20%;
  position: relative;
  display: block;
  border: none;
  width: 100%;
  height: 100%;
  max-width: 100px;
  max-height: 100px;
  border-radius: 3px;
  background: none;
  cursor: pointer;
  user-select: none;
  transition: transform 0.1s;
  z-index: 10;
  padding-top: 20%;
  perspective: 600px;

  &:not(:disabled):not(.is-mobile):hover {
    transform: scale(1.08);
  }

  &:disabled {
    cursor: default;
    z-index: 10;
  }

  &.is-last {
    z-index: 11;
  }
`;

export const SInner = styled.div`
  ${tileStyle};
  transform-style: preserve-3d;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  animation-delay: var(--flip-animation-delay);

  &.opened {
    animation-name: ${flipAnim};
  }
`;

export const SFront = styled.span`
  ${tileStyle};
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  display: block;

  img {
    ${tileStyle};
    pointer-events: none;
    overflow: hidden;
  }
`;

export const SBack = styled.span`
  ${tileStyle};
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  z-index: 1;
  transform: rotateY(180deg);

  &.selectedGold {
    &:before {
      content: '';

      position: absolute;
      top: 20%;
      left: 30%;
      display: block;
      width: 32px;
      height: 32px;
      border-radius: 5px;
      background: rgb(255, 245, 168);
      filter: blur(15px);
      animation: goldPulse ease-in-out 2s forwards;
    }
  }
`;

export const STile = styled.span`
  ${tileStyle};

  &:before,
  &:after {
    content: '';
    ${tileStyle};
    background-image: url('${coinSrc}');
    background-repeat: no-repeat;
    background-size: contain;
    opacity: 0;
  }

  &:after {
    background-image: url('${mineSrc}');
  }

  &.is-dynamite:after,
  &.is-gold:before {
    opacity: 0.4;
  }

  &.selected.is-gold:before,
  &.selected.is-dynamite:after {
    opacity: 1;
  }
`;

export const SStrip = styled.span`
  display: block;
  position: absolute;
  background: var(--strip-bg);
  color: white;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  border-radius: 0 0 4px 4px;
  overflow: hidden;
  height: 26px;
  line-height: 26px;
  bottom: 5%;
  left: 5%;
  width: 90%;
  animation: fadeOut 0.3s;
  animation-fill-mode: forwards;
  animation-delay: 2s;

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    height: 22px;
    line-height: 22px;
  }

  @media (max-width: 350px) and (max-aspect-ratio: 1/1) {
    height: 18px;
    line-height: 18px;
    font-size: 12px;
  }
`;

export const SBonusStrip = styled.span`
  background-size: 100% auto;
  width: 36px;
  height: 45px;
  z-index: 100;
  right: 3px;
  top: 3px;
  position: absolute;
  background: none no-repeat 50% 50%;
  background-size: auto 100%;
  background-image: url('${bonusSrc}');
  pointer-events: none;

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    width: 30px;
    height: 30px;
  }
`;
